import React from 'react';
import ReactDOM from 'react-dom';
import {Result} from '../../common/components/displayItems/results.jsx';

/**
 * Loyalty leaderboard
 */

export default (function() {

	var ItemModel, ItemView, ItemList, ComponentView;

	ItemModel = Backbone.Model.extend();

	// Leaderboard player item
	ItemView = Backbone.View.extend({
		initialize: function(o) {
			this.template = o.template;
		},
		render: function() {
			var obj = this.model.attributes;
			var _itemOpts = this.model.get('itemOpts');
			var _resultComponent = React.createElement( this.template,{
				item: obj,
				templateOpts : {
					variant : _itemOpts.variant
				},
				itemOpts : _itemOpts
			})

			var _el = document.createElement('div');
			ReactDOM.render( _resultComponent, _el);
			this.setElement( _el.children[0]);
			return this;
		}
	});

	ItemList = Backbone.Collection.extend({
		model : ItemModel,
		parse : function(response){
			return response.users
		}
	});

	// The whole leaderboard component (parent view)
	ComponentView = Backbone.View.extend({
		initialize: function() {
			// bind this to ensure scope is properly passed into the event callback.
			var boundFunction = function() {
				this.getFriendsGraph(function(){
					this.createCollection('friends');
				});
			}.bind(this);
			_.bindAll( this, 'getFriendsGraph', 'createCollection', 'storeJson', 'addAll', 'addItem' );
			this.$list = $( '#xLeaderboard_' + this.el.id + ' .xContainerInner' );
			// as soon as we have an FB accessToken get the friends list, then update the model
			if (NGX.App.state.currentUser.accessToken) {
				boundFunction();
			}
			else {
				NGX.App.Events.once('fb:ready', boundFunction);
			}
		},
		// create a named collection within this view
		createCollection: function(name) {
			var list = this[name] = new ItemList({ el: this.$list });
			this.listenTo(list, 'reset', this.addAll);
			this.listenTo(list, 'add', this.addItem);
			list.url = '/display/gamification/' + ( this.model.get('showOnlyFriends')? 'friendsProfile': 'leaderboard' ) + '.json';
			list.fetch({
				success: this.storeJson,
				data: {
					apikey	   : NGX.context.apikey,
					criteria   : this.model.get('sortFriendsBy') || 'points', // 'points' or 'badges'
					friends_ids: this.friendList,
					preview	   : NGX.context.isPreview,
                    max        : this.model.get('maxItems') || 100
				}
			});
		},
		// make a FB graph request for the current user's friends (used to show them in the leaderboard)
		getFriendsGraph: function(callback) {
			$.ajax({
				context: this,
				url: 'https://graph.facebook.com/' + NGX.context.fb.apiVersion + '/me?fields=friends.fields(id)',
				data: {
					access_token: NGX.App.state.currentUser.accessToken
				},
				dataType: 'json'
			})
				.done(function(response) {
					this.friendList = _.pluck(response.friends.data, 'id').join(',');
				})
				.complete(function(){
					callback.call(this);
				});
		},
		// storeJson is used for list item sharing
		storeJson: function(collection, response) {
			this.model.set('response', response);
		},
		// build & render views for a whole collection
		addAll: function(collection) {
			_.each(collection.models, function(model) {
				this.addItem( model )
			}, this);
		},
		// build and render an item view from its model
		addItem: function(model) {
			var obj = {
				model: model,
				template: Result
			};
            obj.model.set('itemOpts',this.model.get('itemOpts'));
			this.$list.append( new ItemView( obj ).render().el );
		}
	});

	// register new view against a component type
	NGX.comps.push({type:'leaderboardloyalty',  view:ComponentView});

}());